module.exports = __webpack_public_path__ + "img/vote_illustration3.78ca91dc.png";